export default __webpack_public_path__ + "static/media/noDataAvailable.7411dd3b.png";